// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__mSlrz","header":"style_header__vI2jo","main_text":"style_main_text__F4fDk","subText":"style_subText__6tGoW"};